import { ClientTask, DashboardClient, TaskKind } from './types';

const TAB_FOR_KIND: Record<TaskKind, string> = {
  report: 'reports',
  assessment: 'assessments',
  session: 'sessions',
  checkin: 'check-ins',
  success: 'success',
  renewal: 'overview',
};

/** Where a task gets done: the client's page, on the tab that holds it. */
export const taskHref = (client: Pick<DashboardClient, 'docId'>, task: Pick<ClientTask, 'kind'>) =>
  `/clients/${encodeURIComponent(client.docId)}?tab=${TAB_FOR_KIND[task.kind]}`;

export const clientHref = (client: Pick<DashboardClient, 'docId'>) => `/clients/${encodeURIComponent(client.docId)}`;
